import { combineEpics } from 'redux-observable'
import { Observable } from 'rxjs/Observable'

import { generateCustomizedSyncBody } from 'utils/CustomizedSync'

import { saveQuickIntegrationError, saveQuickIntegrationSuccess } from './actions'
import { QUICK_INTEGRATION_SAVE_ASYNC } from './constants'

const saveQuickIntegrationEpic = (action$, store, { api, epicsErrorHandler }) =>
  action$.ofType(QUICK_INTEGRATION_SAVE_ASYNC.INITIATE).mergeMap((action) =>
    api.settings
      .saveQuickIntegration(store.getState().partnerOptions.selectedCompany?.value, {
        ...store.getState().settings.emailServer.quickIntegration.data,
        ...action.payload.data,
        ...generateCustomizedSyncBody(store),
      })
      .map((response) => saveQuickIntegrationSuccess(response))
      .catch((error) => Observable.of(epicsErrorHandler(saveQuickIntegrationError, error)))
  )

export default combineEpics(saveQuickIntegrationEpic)
